import type { User } from '../model';
import { getUser, getUsers } from '../rest';
import { transformUser, transformUsers } from './transformers';

export const requestUser = (baseUrl: string, accountId: string): Promise<User> =>
	getUser(baseUrl, accountId).then(transformUser);

export const requestUsers = (baseUrl: string, query: string): Promise<User[]> =>
	getUsers(baseUrl, query).then(transformUsers);
